<template>
  <div>
    <a-button type="primary" @click="showModal">
      BS-OTH-01-001
    </a-button>
    <a-modal v-model="visible" :footer="null">
      <n-card class="n-card" :bordered="false" size="huge">
        <h3>フィードバックを送信</h3>
        <div class="descrition">ベネフィット・ステーションについてのご意見をお聞かせください。</div>
        <div class="sub-title">フィードバックの種類（必須）</div>
        <div class="checkbox-s">
          <a-checkbox class="a-checkbox">問題を報告</a-checkbox>
          <a-checkbox class="a-checkbox">機能改善を依頼</a-checkbox>
          <a-checkbox class="a-checkbox">その他</a-checkbox>
        </div>
        <div class="sub-title">フィードバック内容（必須）</div>
        <a-input class="a-input" type="textarea" placeholder="できるだけ詳しく入力してください。" />
        <button class="btn-add">
          <span class="icon icon-plus-action"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
          <span class="font-bold">スクリーンショットを追加</span>
        </button>
        <div class="mb-8">
          <div class="sub-title">報告対象となるページのURL</div>
          <a-input v-model="linkwebsite" type="text" placeholder="Basic Input" />
        </div>    
        <div class="style-btn">
          <button class="c-btn btn-white left-btn">キャンセル</button>
          <button class="c-btn btn-grey">送信する</button>
        </div>
        </n-card>
    </a-modal>
  </div>
</template>

<script>

export default {
  data() {
    return {
      visible: false,
      linkwebsite: 'https://bs.benefit-one.co.jp/bs/'
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleOk() {
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './styles.scss';
</style>